import GeneralInfo from 'src/pages/about/GeneralInfo'

const GeneralInfoPage = () => <GeneralInfo />

export default GeneralInfoPage
